/**
 * プランバッジ
 *
 * 現在のプランをアイコン + プラン名のピルで示す。
 * 名前は幅を取らない短い方（PLAN_SHORT_NAME: 無料 / ベーシック / プレミアム）を使う。
 * 色は PlanInfoCard のバッジと揃えてある（無料=グレー / ベーシック=セージ / プレミアム=オリーブ）。
 *
 * 高さは 20px（h-5）固定。text-sm（line-height 20px）の行に `align-top` で置くと、
 * 行ボックスとちょうど同じ高さになり、隣の文字と上下中央が揃う。
 *
 * 料金ページ（/pricing）のプランアイコン画像は大きく見せる前提の写実的なイラストで、
 * バッジサイズまで縮めると潰れるため、ここでは Heroicons を使う。
 */

import { UserIcon, StarIcon, TrophyIcon } from '@heroicons/react/24/outline';
import { PLAN_TYPE, PLAN_SHORT_NAME, type PlanType } from '@/constants/planTypes';

const PLAN_STYLE: Record<PlanType, { icon: typeof UserIcon; className: string }> = {
  [PLAN_TYPE.FREE]: {
    icon: UserIcon,
    className: 'bg-text-100 text-text-700',
  },
  [PLAN_TYPE.BASIC]: {
    icon: StarIcon,
    className: 'bg-secondary-100 text-secondary-700',
  },
  [PLAN_TYPE.PREMIUM]: {
    icon: TrophyIcon,
    className: 'bg-primary-600 text-white',
  },
};

interface PlanBadgeProps {
  planType: PlanType;
  className?: string;
}

export default function PlanBadge({ planType, className = '' }: PlanBadgeProps) {
  const { icon: Icon, className: planClass } = PLAN_STYLE[planType];

  return (
    <span
      className={`inline-flex items-center gap-1 pl-1.5 pr-2 h-5 rounded-full text-xs font-medium ${planClass} ${className}`}
    >
      <Icon className="w-3.5 h-3.5 shrink-0" />
      {PLAN_SHORT_NAME[planType]}
    </span>
  );
}
